"use strict";
exports.__esModule = true;
exports.RESUME_ONBOARDING_STEPS = void 0;
exports.RESUME_ONBOARDING_STEPS = {
    BODY: 'Just a few more steps until you’re ready to use Flex.',
    ACCOUNT_CREATION: 'Create account',
    PROPERTY_SELECTION: 'Add property',
    CREDIT_ELIGIBILITY_CHECK: 'Connect credit profile',
    REPAYMENT_SCHEDULING: 'Set up payments',
    OFFER_ACCEPT: 'Finalize schedule',
    HEADER: 'Welcome back, {{name}}!',
    CTA: 'Let’s go',
    BODY_ITS_BEEN_A_WHILE: 'It’s been a while. Let’s review your information to make sure it’s up to date.'
};
